import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { Checkbox } from 'components/forms'

import { updateProductFilters } from '../actions'

export const ProductAvailabilityToggle = ({
  defaultChecked,
  onChange,
  value,
}) => {
  return (
    <Checkbox
      defaultChecked={defaultChecked}
      key={value}
      label="Only show items currently in-stock"
      onChange={onChange}
      tappable
      value={value}
    />
  )
}

ProductAvailabilityToggle.propTypes = {
  value: PropTypes.string.isRequired,
  defaultChecked: PropTypes.bool,
  onChange: PropTypes.func,
}

ProductAvailabilityToggle.defaultProps = {
  onChange: () => {},
  defaultChecked: false,
}

const mapDispatchToProps = (dispatch) => ({
  onChange: (event) =>
    dispatch(
      updateProductFilters({ [event.target.value]: event.target.checked })
    ),
})

const mapStateToProps = (state) => ({
  defaultChecked: state.productFilters?.available,
})

export const ProductAvailabilityFilter = connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductAvailabilityToggle)

const DEFAULT_FILTER_KEY = 'available'

ProductAvailabilityFilter.defaultProps = {
  value: DEFAULT_FILTER_KEY,
}
